import { z } from 'zod';

import {
  type BaseFlowBlock,
  BaseFlowBlockSchema,
  BlockType,
  ProducedType,
  returnTypeSchema,
} from '../base/baseSchema.js';

// @deprecated
export interface OcrBlock extends BaseFlowBlock {
  type: BlockType.Ocr;
  config: {
    gsPaths: {
      gsPath: string;
    }[];
  };
}

export enum OcrDetailLevel {
  None = 'none',
  Page = 'page',
  Block = 'block',
  Paragraph = 'paragraph',
  Word = 'word',
  Symbol = 'symbol',
}

export enum OcrBoundingBoxMode {
  None = 'none',
  All = 'all',
}

export const OcrV2BlockConfigSchema = z.object({
  fileReference: z.string().min(1),
  detailLevel: z.nativeEnum(OcrDetailLevel).default(OcrDetailLevel.None),
  boundingBoxMode: z.nativeEnum(OcrBoundingBoxMode).default(OcrBoundingBoxMode.None),
  useVisionOcrModel: z.boolean().default(false),
});
export type OcrV2BlockConfig = z.infer<typeof OcrV2BlockConfigSchema>;

export const OcrV2BlockSchema = BaseFlowBlockSchema.extend({
  type: z.literal(BlockType.OcrV2),
  config: OcrV2BlockConfigSchema,
  returnType: returnTypeSchema(ProducedType.OcrDetailResponse),
});
export type OcrV2Block = z.infer<typeof OcrV2BlockSchema>;
